import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import SaveStatus from "../../UIComponents/SaveStatus";
import GeozoneInfoObj from "../GeozoneInfoObj"
import MenuDropdown from '../baseComponents/Dropdown/MenuDropdown';

import useStyles from "./useStyles";
import mapStateToProps from './mapStateToProps'

function deactivateAll(arr) {
    return arr.map(item => ({
        ...item,
        active: false
    }));
}

const GeozonePalette = () => {

    const {
        geoObjGeozone,
        geozoneArr = [],
        geozoneSettingsArr = [],

        loadGeozone = () => { },
        updateGeozoneSettingsArr = () => { },
    } = useSelector(mapStateToProps)

    const classes = useStyles();

    useEffect(() => {
        if (!geozoneArr?.length) {
            loadGeozone()
        }
    }, [])

    const updateItem = async (index, newItem) => {
        // сбросить все активные геозоны
        const clearedArr = deactivateAll(geozoneSettingsArr)
        // рассчитать новый массив выбранных геозон
        const updatedSettingsArr = clearedArr.map((item, i) => (i === index ? newItem : item))
        updateGeozoneSettingsArr(updatedSettingsArr)

    }

    return (
        <div className={classes.dropdown}>
            <div className={classes.dropdownCont}>
                <SaveStatus title="Загрузка геозон" dataObj={geoObjGeozone} errShowTime={1000} successShowTime={100} />
                <MenuDropdown title='Геозоны' total={geozoneSettingsArr.length} showSelectAll={false} open>
                    {geozoneSettingsArr.map((dataObj, i) => {
                        return (
                            <GeozoneInfoObj
                                dataObj={{ ...dataObj, ...geozoneArr[i] }}
                                updateDataObj={(newDataObj) => updateItem(i, newDataObj)}
                                key={i}
                            />
                        )
                    })}
                </MenuDropdown>
            </div>
        </div>
    )
}
export default GeozonePalette